// Persona chip — reuses the exact color logic from the Opportunities
// DealIntentBlock (confirmed = blue, suggested = gray, none = muted) so the
// AI persona reads consistently across the CRM.

interface PersonaChipProps {
  label?: string | null;
  role?: string | null;
  status?: string | null; // 'suggested' | 'confirmed'
  size?: 'xs' | 'sm';
  showRole?: boolean;
  hideWhenEmpty?: boolean;
}

export default function PersonaChip({
  label,
  role,
  status,
  size = 'sm',
  showRole = true,
  hideWhenEmpty = false,
}: PersonaChipProps) {
  if (hideWhenEmpty && !label) return null;

  const pad = size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-xs px-2 py-0.5';
  const color =
    status === 'confirmed'
      ? 'bg-info-wash text-info'
      : label
      ? 'bg-gray-100 text-gray-600'
      : 'bg-gray-50 text-gray-400';

  return (
    <span className="inline-flex items-center gap-1 flex-wrap">
      <span className={`${pad} rounded font-medium ${color}`}>{label || 'No persona yet'}</span>
      {showRole && role === 'both' && (
        <span className={`${size === 'xs' ? 'text-[9px] px-1' : 'text-[10px] px-2'} py-0.5 rounded bg-success-wash text-success font-medium`}>
          buy + sell
        </span>
      )}
    </span>
  );
}
